import { IconProps } from '../../icons/types';

const InfoNotification = (props: IconProps) => {
  const { width = 36, height = 36 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="18" fill="#E6F1FF" />
      <mask id="mask0_2225_23276" maskUnits="userSpaceOnUse" x="8" y="8" width="20" height="20">
        <rect x="8" y="8" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2225_23276)">
        <path
          d="M17.9998 22.166C18.2359 22.166 18.434 22.086 18.594 21.926C18.7534 21.7666 18.8332 21.5688 18.8332 21.3327V17.9785C18.8332 17.7424 18.7534 17.548 18.594 17.3952C18.434 17.2424 18.2359 17.166 17.9998 17.166C17.7637 17.166 17.5659 17.2457 17.4065 17.4052C17.2465 17.5652 17.1665 17.7632 17.1665 17.9993V21.3535C17.1665 21.5896 17.2465 21.7841 17.4065 21.9368C17.5659 22.0896 17.7637 22.166 17.9998 22.166ZM17.9998 15.4993C18.2359 15.4993 18.434 15.4193 18.594 15.2593C18.7534 15.0999 18.8332 14.9021 18.8332 14.666C18.8332 14.4299 18.7534 14.2318 18.594 14.0718C18.434 13.9124 18.2359 13.8327 17.9998 13.8327C17.7637 13.8327 17.5659 13.9124 17.4065 14.0718C17.2465 14.2318 17.1665 14.4299 17.1665 14.666C17.1665 14.9021 17.2465 15.0999 17.4065 15.2593C17.5659 15.4193 17.7637 15.4993 17.9998 15.4993ZM17.9998 26.3327C16.8471 26.3327 15.7637 26.1138 14.7498 25.676C13.7359 25.2388 12.854 24.6452 12.104 23.8952C11.354 23.1452 10.7604 22.2632 10.3232 21.2493C9.88539 20.2355 9.6665 19.1521 9.6665 17.9993C9.6665 16.8466 9.88539 15.7632 10.3232 14.7493C10.7604 13.7355 11.354 12.8535 12.104 12.1035C12.854 11.3535 13.7359 10.7596 14.7498 10.3218C15.7637 9.88463 16.8471 9.66602 17.9998 9.66602C19.1526 9.66602 20.2359 9.88463 21.2498 10.3218C22.2637 10.7596 23.1457 11.3535 23.8957 12.1035C24.6457 12.8535 25.2393 13.7355 25.6765 14.7493C26.1143 15.7632 26.3332 16.8466 26.3332 17.9993C26.3332 19.1521 26.1143 20.2355 25.6765 21.2493C25.2393 22.2632 24.6457 23.1452 23.8957 23.8952C23.1457 24.6452 22.2637 25.2388 21.2498 25.676C20.2359 26.1138 19.1526 26.3327 17.9998 26.3327Z"
          fill="#0276FE"
        />
      </g>
    </svg>
  );
};

export default InfoNotification;
